module.exports = __webpack_public_path__ + "static/media/ImgSignInBg.af15cc9c.svg";